export function removeString(string) {
  if (string !== null && string !== "" && string !== undefined) {
    const stripped = string.toString().replace(/,/g, "");
    string = stripped;
  }

  return string;
}
export function removeStringObj(obj) {
  let result = [];
  for (const data of obj) {
    Object.keys(data).map(function(key) {
      if (key !== "description" && key !== "note" && key !== "no_entry") {
        if (data[key] !== null) {
          const stripped = data[key].toString().replace(/,/g, "");
          data[key] = stripped;
        }
      }
      return null;
    });
    result.push(data);
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/services/formatServices.js